/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import ChargingStation from "components/ChargingStation/ChargingStation";
import ConfirmDeleteConnector from "components/ChargingStation/ConnectorConformDelete";
import React, { Component } from "react";
import { chargingStationApi } from "stores/ChargingStationStore/chargingStationApi";
import addStationApis from "stores/AddStationStore/addStationApi";


import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import AddStationForm from "components/ChargingStationTable/AddStationForm";
import { commonApis } from "stores/common/commonApis";
import { validationHelper } from "helper/validation";
import format from "date-fns/format";
import ChargingStationExcelUpload from "components/ChargingStation/ChargingStationBulkUpload";
import DailogDeleteChargingStation from "./DailogDeleteChargingStation";
function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
export default class ChargingStationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modelopen: false,
      page: 0,
      limit: 100,
      formData: {
        open: false,
        name: "",
        email: "",
        mobile: "",
        type: "",
        open_time: new Date(),
        close_time: new Date(),
        network_id: "",
        station_url: "",
        landmark: "",
        address: "",
        address2: "",
        pin: "",
        street: "",
        city: "",
        state: "",
        country: "India",
        latitude: "",
        longitude: "",
        attachment_ids: [],
        amenities: [],
        formData: {
          from_date: "",
          to_date: "",
        },
        charging_points: [
          {
            name: "",
            cp_id: "",
            connectors: [
              {
                charger_type_id: "",
                price_per_khw: "",
                power: "",
              },
            ],
          },
        ],

        dynamic_amenities: [],
      },
      formError: {
        name: false,
        date_of_birth: false,
        email: false,
        mobile: false,
        network_id: false,
        type: false,
        open_time: false,
        close_time: false,
        station_url: false,
        landmark: false,
        address: false,
        address2: false,
        pin: false,
        street: false,
        city: false,
        state: false,
        country: false,
        latitude: false,
        longitude: false,
        images: [],
        station_id: false,
        cp_id: false,
        connectors: [],
        charging_points: [
          {
            name: false,
            cp_id: false,
            connectors: [
              {
                charger_type_id: false,
                price_per_khw: false,
                power: false,
              },
            ],
          },
        ],
        dynamic_amenities: [],
      },
      isLoading: false,
      setOpen: false,
      files: [],
      snackbar: false,
      ErrorMsg: "",
      snackbarError: false,
      dropdowndata: "",
      formDatastation: {
        name: "",
        stations_id: "",
        cp_id: "",
        connectors: [
          {
            charger_type_id: "",
            price_per_kwh: "",
            power: "",
          },
        ],
      },
      connectorAdd: {
        charge_point_id: "",
        charger_type_id: "",
        power: "",
        price_per_kwh: "",
      },
      chargingPointEdit: {
        id: "",
        name: "",
        station_id: "",
        cp_id: "",
      },
      deleteConnectorId: "",
      deleteConfirmConnectorDialog: false,
      deleteSuccess: false,
      renderComponent: "",
      chargingStion: true,
      selectedStations:[],
      deleteStationOpen:false,
      chargingdeletSuccess:false,
      networkStatus:'',
      inputSearch:''


    };

    this.debouncedSearch = debounce(this.performSearch.bind(this), 500);
  }
  performSearch(searchQuery) {
    if (searchQuery) {
      this.props.getChargingStationsAction({
        search_term: searchQuery,
        limit: this.state.limit,
        page: this.state.page,
      });
      return;
    }
    else{
      this.props.getChargingStationsAction({
        // search_term: searchQuery,
        limit: this.state.limit,
        page: this.state.page,
      });
    }
    // } else
    //   this.props.getNetworkTableAction({
    //     limit: this.state.limit,
    //     page: this.state.page,
    //   });
  }
  handleDeleteStationOpen=()=>{
    this.setState({
      deleteStationOpen:true
    })
  }
  handleDeleteStationClose=()=>{
    this.setState({
      deleteStationOpen:false
    })
  }

  handleSelectionChange = (stationId) => {
    console.log("fhue",stationId);
    
    this.setState((prevState) => {
      const selectedStations = prevState.selectedStations || [];
      return {
        selectedStations: selectedStations.includes(stationId)
          ? selectedStations.filter((id) => id !== stationId)
          : [...selectedStations, stationId],
      };
    });
  };

  handleAddConnnector = (addType) => {
    if (addType === "AddChargingStation") {
      this.setState({ renderComponent: "AddChargingStation" });
      this.setState({ chargingStion: false });
    } else {
      this.setState({ renderComponent: "" });
    }
  };
  handleDeleteStation = async () => {
    try {
      const res = await chargingStationApi.deleteStationApi(this.state.selectedStations);
      if (res && res.status === 1) {
        this.props.getChargingStationsAction();
        this.handleDeleteStationClose();
        this.setState({chargingdeletSuccess:true})
      } else {
        console.warn("Delete operation unsuccessful:", res);
      }
    } catch (error) {
      console.error("Error deleting connector:", error);
    }
  };
  componentDidMount() {
    this.props.getChargingStationsAction();
    this.props.getChargingConnectorDropdownAction();
    this.props.getChargingNetworDropdownAction();
    this.props.getAmenitiesAction();
    this.props.getNetworkAction();
    this.props.chargerTypeAction();
  }
  // add ststion
  async getKeyByValue(object, value) {
    for (let i = 0; i < object.length; i++) {
      // eslint-disable-next-line eqeqeq
      if (object[i].name == value) {
        return object[i].id;
      }
    }
  }

  handleChangeAddChargingPoint = (index, event) => {
    let data = [...this.state.formData.charging_points];
    data[index][event.target.name] = event.target.value;
    this.setState({
      formData: { ...this.state.formData, charging_points: data },
    });
  };

  addFieldsAddChargingPoint = () => {
    let newFields = { name: "", cp_id: "", connectors: [] };

    let data = [...this.state.formData.charging_points];
    data.push(newFields);
    this.setState({
      formData: { ...this.state.formData, charging_points: data },
    });

    let newFieldserror = { name: false, cp_id: false, connectors: [] };

    let dataerror = [...this.state.formError.charging_points];
    dataerror.push(newFieldserror);
    this.setState({
      formError: { ...this.state.formError, charging_points: dataerror },
    });
  };

  removeFieldsChargingPoint = (index) => {
    let data = [...this.state.formData.charging_points];
    data.splice(index, 1);
    this.setState({
      formData: { ...this.state.formData, charging_points: data },
    });
  };

  handleAmenityGet = () => {
    this.props.amenityGetAction({
      latitude: this.state.formData.latitude,
      longitude: this.state.formData.longitude,
    });
  };

  //connectors

  handleChangeAddChargingConnector = (i, event, j) => {
    let data = [...this.state.formData.charging_points];
    data[i]["connectors"][j][event.target.name] = event.target.value;

    this.setState({
      formData: { ...this.state.formData, charging_points: data },
    });
  };

  addFieldsAddChargingConnector = (index) => {
    let newFields = { charger_type_id: "", power: "", price_per_khw: "" };
    let data = [...this.state.formData.charging_points];
    // data.push(newFields);
    data[index].connectors.push(newFields);
    this.setState({
      formData: { ...this.state.formData, charging_points: data },
    });

    let newFieldserror = {
      charger_type_id: false,
      power: false,
      price_per_khw: false,
    };
    let dataerror = [...this.state.formError.charging_points];
    // data.push(newFields);
    dataerror[index].connectors.push(newFieldserror);
    this.setState({
      formError: { ...this.state.formError, charging_points: dataerror },
    });
  };

  removeFieldsChargingConnector = (index, j) => {
    let chargingPoint = this.state.formData.charging_points;
    chargingPoint[index]?.connectors.splice(j, 1);

    this.setState({
      formData: { ...this.state.formData, charging_points: chargingPoint },
    });
  };

  // handleChangeConnectorAddStation = (index, event) => {
  //   let data = [...this.state.formData.connectors];
  //   data[index][event.target.name] = event.target.value;
  //   this.setState({ formData: { ...this.state.formData, connectors: data } });
  // };

  handleInputChange = (name, value) => {
    const { formData } = this.state;
    if (name === "mobile" && isNaN(value)) {
      return;
    }
    if (name === "pin" && isNaN(value)) {
      return;
    }
    if (name === "latitude" && isNaN(value)) {
      return;
    }
    if (name === "longitude" && isNaN(value)) {
      return;
    }

    if (name === "amenities") {
      formData[name] = value;
      this.setState({ formData });
    }

    // if(name === "open_time" || name === "close_time"){
    //   let date = new Date(value);
    //   value = format(date, "HH:mm");

    // }

    formData[name] = value;
    this.setState({ formData });
  };

  // handleChangeDynamicAmenity = (e) => {
  //   var
  //   this.setState({ formData: { dynamic_amenities: e } });
  // };
  handleChangeDynamicAmenity = (event) => {
    const dynamicAmenities = event;
    this.setState({
      formData: { ...this.state.formData, dynamic_amenities: dynamicAmenities },
    });
  };

  handleClickOpen = () => {
    this.setState({ setOpen: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleValidation = () => {
    const { formError, formData } = this.state;

    const nameValidation = validationHelper.name(formData.name);
    formError.name = nameValidation.message;

    // const emailValidation = validationHelper.email(formData.email);
    // formError.email = emailValidation.message;

    // const mobileValidation = validationHelper.mobile(formData.mobile);
    // formError.mobile = mobileValidation.message;

    const networkIdValidation = validationHelper.networkId(formData.network_id);
    formError.network_id = networkIdValidation.message;

    const typeValidation = validationHelper.typeChargingStation(formData.type);
    formError.type = typeValidation.message;

    // const stationUrlValidation = validationHelper.stationUrl(
    //   formData.station_url
    // );
    // formError.station_url = stationUrlValidation.message;

    const addressValidation = validationHelper.address(formData.address);
    formError.address = addressValidation.message;

    // const landmarkValidation = validationHelper.landmark(formData.landmark);
    // formError.landmark = landmarkValidation.message;

    // const pinValidation = validationHelper.pin(formData.pin);
    // formError.pin = pinValidation.message;

    // const streetValidation = validationHelper.street(formData.street);
    // formError.street = streetValidation.message;

    // const cityValidation = validationHelper.city(formData.city);
    // formError.city = cityValidation.message;

    const latitudeValidation = validationHelper.latitude(formData.latitude);
    formError.latitude = latitudeValidation.message;

    const longitudeValidation = validationHelper.longitude(formData.longitude);
    formError.longitude = longitudeValidation.message;

    // var charginPointValidation = false;

    // formData.charging_points.map((item, i) => {
    //   const chargingPointName = validationHelper.name(item.name);
    //   formError.charging_points[i].name = chargingPointName.message;

    //   const chargingPointId = validationHelper.networkId(item.cp_id);
    //   formError.charging_points[i].cp_id = chargingPointId.message;

    //   item.connectors.map((item2, j) => {
    //     const ConnectorsPower = validationHelper.networkId(item2.power);
    //     formError.charging_points[i].connectors[j].power =
    //       ConnectorsPower.message;

    //     const ConnectorsRate = validationHelper.networkId(item2.price_per_khw);
    //     formError.charging_points[i].connectors[j].price_per_khw =
    //       ConnectorsRate.message;
    //     if (
    //       chargingPointName.isValid &&
    //       chargingPointId.isValid &&
    //       ConnectorsPower.isValid &&
    //       ConnectorsRate.isValid
    //     ) {
    //       charginPointValidation = true;
    //     }
    //   });
    // });

    this.setState({ formError });

    return (
      nameValidation.isValid &&
      // emailValidation.isValid &&
      // mobileValidation.isValid &&
      networkIdValidation.isValid &&
      // stationUrlValidation.isValid &&
      addressValidation.isValid &&
      // landmarkValidation.isValid &&
      // pinValidation.isValid &&
      // streetValidation.isValid &&
      // cityValidation.isValid &&
      latitudeValidation.isValid &&
      longitudeValidation.isValid 
      // charginPointValidation
    );
  };
  
  handleFormSubmit = async () => {
    if (!this.handleValidation()) {
      return;
    }

    this.setState({ isLoading: true });
    const { formData } = this.state;

    let newAmenities = [];
    for (let am = 0; am < formData.amenities.length; am++) {
      let amKey = await this.getKeyByValue(
        this.props.amenitiesData,
        formData.amenities[am]
      );
      newAmenities.push(amKey);
    }

    try {
      const res = await addStationApis.addStation({
        name: formData.name,
        mobile: formData.mobile,
        email: formData.email,
        network_id: formData.network_id,
        type: formData.type,
        open_time: format(formData.open_time, "HH:mm"),
        close_time: format(formData.close_time, "HH:mm"),
        station_url: formData.station_url,
        landmark: formData.landmark,
        address: formData.address,
        address2: formData.address2,
        pin: formData.pin,
        street: formData.street,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        latitude: formData.latitude,
        longitude: formData.longitude,
        attachment_ids: formData.attachment_ids,
        amenities: newAmenities,
        charging_points: formData.charging_points,

      });
      console.log("wgsgsw",res);
      if (res.status === 1) {
       
        this.setState({
          snackbar: true,
          formData: {
            name: "",
            mobile: "",
            email: "",
            network_id: "",
            type: "",
            open_time: "",
            close_time: "",
            station_url: "",
            landmark: "",
            address: "",
            address2: "",
            pin: "",
            street: "",
            city: "",
            state: "",
            country: "",
            latitude: "",
            longitude: "",
            attachment_ids: [],
            amenities: [],
          },
        });
        this.props.getChargingStationsAction();
        this.setState({ renderComponent: "" });
       
      } else {
        this.setState({ ErrorMsg: res.message });
        this.setState({ snackbarError: true });
      }
    } catch (e) {
      if (e.response) {
        this.setState({ ErrorMsg: e.response.data.message });
        this.setState({ snackbarError: true });
      }
    }
  };

  // handleFormSubmit = async () => {
  //   const { postaddstations } = this.props;
  //   if (!this.handleValidation()) {
  //     return;
  //   }

  //   this.setState({ isLoading: true });
  //   const { formData } = this.state;

  //   let newAmenities = [];
  //   for (let am = 0; am < formData.amenities.length; am++) {
  //     let amKey = await this.getKeyByValue(
  //       this.props.amenitiesData,
  //       formData.amenities[am]
  //     );
  //     newAmenities.push(amKey);
  //   }
    
  //  postaddstations({
  //     name: formData.name,
  //     mobile: formData.mobile,
  //     email: formData.email,
  //     network_id: formData.network_id,
  //     type: formData.type,
  //     open_time: format(formData.open_time, "HH:mm"),
  //     close_time: format(formData.close_time, "HH:mm"),
  //     station_url: formData.station_url,
  //     landmark: formData.landmark,
  //     address: formData.address,
  //     address2: formData.address2,
  //     pin: formData.pin,
  //     street: formData.street,
  //     city: formData.city,
  //     state: formData.state,
  //     country: formData.country,
  //     latitude: formData.latitude,
  //     longitude: formData.longitude,
  //     attachment_ids: formData.attachment_ids,
  //     amenities: newAmenities,
  //     connectors: formData.connectors,
  //     charging_points: formData.charging_points,
  //     dynamic_amenities: this.props.amenityGet,
  //   });
  //   this.props.getChargingStationsAction();
  //   this.setState({ renderComponent: "" });
  //   // if (res.status === 1) {

  //   //   // this.setState({ snackbar: true , });
  //   //   this.handleClickOpen();

  //   //   this.props.history.push({
  //   //     pathname: "/charging",
  //   //     state: {
  //   //       id: res.result.id,
  //   //     }
  //   //   });

  //   // } catch (e) {
  //   //   if (e.response) {
  //   //     this.setState({ ErrorMsg: e.response.data.message });
  //   //     this.setState({ snackbarError: true });
  //   //   }
  //   // }
  // };

  handleImageChange = async (files) => {
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        try {
          const res = await commonApis.uploadAttachment({
            file: files[i],
            type: "IMAGE",
            attachment_of: "Station",
          });

          if (res.status === 1) {
            const { formData } = this.state;
            formData.attachment_ids.push(res.result.id);
            this.setState({ formData });
          }
        } catch (e) {
          console.log(e);
        } finally {
        }
      }
    }
  };
  // eslint-disable-next-line no-dupe-class-members
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  //add station

  // componentDidUpdate(prevProps) {
  //   if (prevProps.chargingStationData !== this.props.chargingStationData) {
  //     const firstStationId = this.props.chargingStationData[0]?.id || "";
  //     this.setState((prevState) => ({
  //       formDatastation: {
  //         ...prevState.formDatastation,
  //         station_id: firstStationId,
  //       },
  //     }));
  //   }
  // }
  componentDidUpdate(prevProps) {
    const { chargingStationData } = this.props;

    if (prevProps.chargingStationData !== chargingStationData) {
      const firstStationId = chargingStationData[0]?.id || "";

      this.setState((prevState) => ({
        formDatastation: {
          ...prevState.formDatastation,
          station_id: firstStationId,
        },
      }));
    }
  }
  handleModelClose = () => {
    this.setState({ modelopen: false });
  };
  handleModelOpen = () => {
    this.setState({ modelopen: true });
  };

  handleDeleteConfirmConnectorClick = (id) => {
    this.setState({
      deleteConfirmConnectorDialog: true,
      deleteConnectorId: id,
    });
  };

  handleCloseDeleteConnectorConfirm = () => {
    this.setState({
      deleteConfirmConnectorDialog: false,
    });
  };

  handleSubmitAddChPoint = async (data, Id) => {
    const payload = {
      name: data.name,
      station_id: Id,
      cp_id: data.cp_id,
      connectors: data.connectors.map((connector) => ({
        charger_type_id: connector.charger_type_id,
        power: connector.power,
        price_per_khw: connector.price_per_khw,
      })),
    };

    // eslint-disable-next-line no-unused-vars
    const res = await chargingStationApi.Add_ChargingPointApi(payload);
    this.props.getChargingPointAction(this.state.stations_id);
    this.props.getChargingStationsAction();
  };

  handleDeleteConnectorChargingClick = () => {
    let id = this.state.deleteConnectorId;
    if (id !== undefined) {
      this.props.deleteChargingConnectorAction({ id });
      this.props.getChargingPointAction(this.state.stations_id);
      this.setState({
        deleteConfirmConnectorDialog: false,
        deleteConnectorId: "",
      });
      this.setState({ deleteSuccess: true });
    }
    this.props.getChargingPointAction(this.state.stations_id);
    this.props.getChargingStationsAction();
  };
  handleNetworkStatusChange = async (event) => {
    
    const value = event.target.value;
    console.log("ebfeygyfeg",value);
    
    this.setState({ networkStatus: value });
    try {
      await this.props.getChargingStationsAction({
        network:value
      });
    } catch (error) {
      console.error('Error fetching charging station data:', error);
    }
  };

  handleSubmitEditChPoint = async (data, cpID, sID) => {
    try {
      await chargingStationApi.Edit_ChargingPointApi({
        name: data.name,
        station_id: data.station_id,
        cp_id: data.cp_id,
        id: data.id,
      });
    } catch (error) {}
    this.props.getChargingPointAction(this.state.stations_id);
  };
  handleSubmitEditConnector = async (data, cpID, connectoreditopenid) => {
    try {
      const res = await chargingStationApi.Edit_ChargingConnecApi({
        charger_type_id: data.charger_type_id,
        charge_point_id: data.charge_point_id,
        price_per_khw: data.price_per_khw,
        power: data.power,
        id: connectoreditopenid,
      });
      this.props.getChargingPointAction(this.state.stations_id);
      this.props.getChargingStationsAction();
    } catch (error) {
      console.log(error);
    }
  };

  handleSubmitConnector = async (data, Id) => {
    const res = await chargingStationApi.Add_ChargingConnectorApi({
      charger_type_id: data.charger_type_id,
      power: data.power,
      price_per_khw: data.price_per_khw,
      charge_point_id: Id,
    });
    this.props.getChargingPointAction(this.state.stations_id);
    // this.props.getChargingStationsAction();
  };

  handleChargingPointModalOpen = (id) => {
    this.setState({ stations_id: id });
    this.props.getChargingPointAction(id);
  };
  // date range
  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };
  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };
  handleChange = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    this.handleFilterApiData();
    this.setState({ formData });
  };

  searchhandleChange = (name, value) => {
    const query = value;
    this.setState({inputSearch:query})
    this.setState({ query });
    this.debouncedSearch(query);
  };
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }
  handleFilterApiData = async () => {
    await this.props.getChargingStationsAction({
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
    });
  };

  handleReset = async () =>{
    await this.props.getChargingStationsAction();
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }

  handelfilterdata = async (value) => {
    await this.props.getChargingStationsAction({ sort: value });
  };
  onPageChange = (page, rowsPerPage) => {
    this.setState({
      page: page,
      limit: rowsPerPage,
    });
    const payload = {
      limit: rowsPerPage,
      page: page,
      search_term:this.state.inputSearch,
    };
    this.props.getChargingStationsAction(payload);
  };
  handleExcelSubmit = async (data) => {
    try {
      const res = await chargingStationApi.postBulkData(data);

      if (res.status === 1) {
        this.setState({ open: false });
        this.setState({ addSuccess: true });
      }
    } catch (e) {
      console.log("e.error", e.error);
    }
  };

  render() {
    const chargingDropdown = this.props.ChargingConnectorDropdownList;
    const networkDropdown = this.props.chargingStationNetwork;
    console.log('uhfef',networkDropdown);
    
    switch (this.state.renderComponent) {
      case "AddChargingStation":
        return (
          <div>
            <AddStationForm
              props={this.props}
              onChange={this.handleInputChange}
              handleChangeAddChPoint={this.handleChangeAddChPoint}
              onSubmit={this.handleFormSubmit}
              onImageChange={this.handleImageChange}
              onClickModel={this.handleClickOpen}
              inputFields={this.state.formData.charging_points}
              formData={this.state.formData}
              formError={this.state.formError}
              isLoading={this.state.isLoading}
              handleChangeConnectorAddStation={
                this.handleChangeConnectorAddStation
              }
              handleChangeAddChargingPoint={this.handleChangeAddChargingPoint}
              removeFieldsChargingPoint={this.removeFieldsChargingPoint}
              addFieldsAddChargingPoint={this.addFieldsAddChargingPoint}
              chargerTypes={this.props.chargerTypes}
              handleChangeAddChargingConnector={
                this.handleChangeAddChargingConnector
              }
              addFieldsAddChargingConnector={this.addFieldsAddChargingConnector}
              removeFieldsChargingConnector={this.removeFieldsChargingConnector}
              handleAmenityGet={this.handleAmenityGet}
              amenityGet={this.props.amenityGet}
              handleChangeDynamicAmenity={this.handleChangeDynamicAmenity}
              handleAddConnnector={this.handleAddConnnector}
              networkDropdown={networkDropdown}
            />
          </div>
        );
      default:
        return (
          <div>
            <ChargingStation
              handelfilterdata={this.handelfilterdata}
              handleAddConnnector={this.handleAddConnnector}
              ChargingPointData={this.props.getChargingPointData}
              handleChangeConnectorAdd={this.handleChangeConnectorAdd}
              data={this.props.chargingStationData}
              page={this.state.page}
              limit={this.state.limit}
              totalCount={this.props.chargingStationData?.totalCount}
              handleDeleteConnectorClick={
                this.handleDeleteConfirmConnectorClick
              }
              handleOpenbulk={this.handleModelOpen}
              handleSubmitConnector={this.handleSubmitConnector}
              handleSubmitAddChPoint={this.handleSubmitAddChPoint}
              dropdowndata={chargingDropdown}
              handleSubmitEditChPoint={this.handleSubmitEditChPoint}
              handleSubmitEditConnector={this.handleSubmitEditConnector}
              isLoading={this.props.isLoading}
              handleChargingPointModalOpen={this.handleChargingPointModalOpen}
              searchhandleChange={this.searchhandleChange}
              onChange={this.handleChange}
              datePickerOpen={this.state.datePickerOpen}
              handleDatePickerOpen={this.handleDatePickerOpen}
              handleDatePickerClose={this.handleDatePickerClose}
              from_date={this.state.formData.from_date}
              to_date={this.state.formData.to_date}
              onDatePickerSub={this.onDatePickerSub}
              fromat_date_from={this.state.formData.fromat_date_from}
              fromat_date_to={this.state.formData.fromat_date_to}
              onPageChange={this.onPageChange}
              handleReset={this.handleReset}
              handleSelectionChange={this.handleSelectionChange}
              selectedStations={this.state.selectedStations}
              handleDeleteStationOpen={this.handleDeleteStationOpen}
              networkDropdown={networkDropdown}
              handleNetworkStatusChange={this.handleNetworkStatusChange}

            />
            <ChargingStationExcelUpload
              open={this.state.modelopen}
              handleClose={this.handleModelClose}
              handleExcelSubmit={this.handleExcelSubmit}
            />
            <ConfirmDeleteConnector
              open={this.state.deleteConfirmConnectorDialog}
              handleClose={this.handleCloseDeleteConnectorConfirm}
              handleDelete={this.handleDeleteConnectorChargingClick}
            />
            <DailogDeleteChargingStation
             open={this.state.deleteStationOpen}
             handleClose={this.handleDeleteStationClose}
             handleDelete={this.handleDeleteStation}
            />
             <Snackbar
              open={this.state.chargingdeletSuccess}
              autoHideDuration={3000}
              onClose={() => this.setState({ chargingdeletSuccess: false })}
              message="Charging Stations Deleted Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">
                Charging Stations Deleted Successfully
              </Alert>
            </Snackbar>
            <Snackbar
              open={this.state.deleteSuccess}
              autoHideDuration={3000}
              onClose={() => this.setState({ deleteSuccess: false })}
              message="Charging Connector Deleted Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">
                Charging Connector Deleted Successfully
              </Alert>
            </Snackbar>
            <Snackbar
            open={this.state.snackbar}
            autoHideDuration={3000}
            onClose={() => this.setState({ snackbar: false })}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert severity="success">
              Charging Station Added Successfully
            </Alert>
          </Snackbar>

          <Snackbar
            open={this.state.snackbarError}
            autoHideDuration={3000}
            onClose={() => this.setState({ snackbarError: false })}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert severity="error">{this.state.ErrorMsg}</Alert>
          </Snackbar>
          </div>
        );
    }
  }
}
